import React from 'react';
import { List, Row, Col } from 'antd';
import { blockSubTitle, blockTitle } from './styles';

interface GridImagesProps<T> {
  ListItem: ({ item }: { item: T }) => React.ReactNode;
  items: T[];
  title: string;
  subTitle?: string;
  count?: number;
  column?: number;
}

export const GridImages = <T,>({
  ListItem,
  items = [],
  title = '',
  subTitle,
  count = NaN,
  column = 3,
}: GridImagesProps<T>) => {
  if (isNaN(count)) count = items.length;

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <Row justify="center">
          <Col span={24}>
            <div style={blockTitle}>{title}</div>
          </Col>
          <Col span={24}>
            <div style={blockSubTitle}>{subTitle}</div>
          </Col>
        </Row>
        <Row>
          <List
            grid={{
              gutter: 16,
              lg: column,
              xl: column,
              xxl: column,
              md: column - 1 < 2 ? 1 : column - 1,
              sm: 1,
              xs: 1,
            }}
            dataSource={[...items].slice(0, count)}
            renderItem={item => (
              <List.Item style={{ marginBottom: 16, cursor: 'pointer' }}>
                <ListItem item={item} />
              </List.Item>
            )}
          />
        </Row>
      </Col>
    </Row>
  );
};
